// This file is part of InvenioRDM
// Copyright (C) 2023 CERN.
//
// Invenio App RDM is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

/**
 * Add here all the overridden components of your app.
 */

import {ResourceTypeField} from "../../chicago_invenio/ResourceTypeField";
import {ConditionalCustomFields} from "../../chicago_invenio/ConditionalCustomFields";
import {FileUploaderAreaWithDescriptions} from "../../chicago_invenio/FileUploaderAreaWithDescriptions";
import { parametrize } from "react-overridable";
import { curationComponentOverrides } from "@js/invenio_curations/requests";
import { ChicagoDepositBox } from "../../chicago_invenio/deposit/ChicagoDepositBox";
import { DatesFieldNoEmptyValue } from "../../chicago_invenio/deposit/DatesFieldNoEmptyValue";
import { IdentifiersFieldWithHelpText } from "../../chicago_invenio/deposit/IdentifiersFieldWithHelpText";
import { RelatedWorksFieldNoEmptyValue } from "../../chicago_invenio/deposit/RelatedWorksFieldNoEmptyValue";
import { ReferencesFieldNoEmptyValue } from "../../chicago_invenio/deposit/ReferencesFieldNoEmptyValue";

const ConditionalCustomFieldsWithRules = parametrize(ConditionalCustomFields, {
    sectionRules: {
        "Publishing information": {
            showFor: ['publication-thesis', 'publication-article', 'publication-section', 'publication-book', 'publication-journal'],
            fieldRules: {
                // Thesis fields - only show for thesis publications
                "thesis:thesis": { showFor: ['publication-thesis'] },
                // Journal fields - only show for specific publication types
                "journal:journal": { showFor: ['publication-article', 'publication-journal'] },
                // Imprint fields - only show for specific publication types
                "imprint:imprint": { showFor: ['publication-section', 'publication-book'] }
            }
        },
        "Conference": {
            showFor: ['publication-conferenceproceeding', 'publication-conferencepaper']
        },
        // University of Chicago Information section will show for all types (no rule)
    }
});

export const overriddenComponents = {
    ...curationComponentOverrides,
    "InvenioAppRdm.Deposit.CardDepositStatusBox.container": ChicagoDepositBox,
    "InvenioAppRdm.Deposit.ResourceTypeField.container": ResourceTypeField,
    "InvenioAppRdm.Deposit.CustomFields.container": ConditionalCustomFieldsWithRules,
    "ReactInvenioDeposit.FileUploader.FileUploaderArea.container": FileUploaderAreaWithDescriptions,
    "InvenioAppRdm.Deposit.DateField.container": DatesFieldNoEmptyValue,
    "InvenioAppRdm.Deposit.IdentifiersField.container": IdentifiersFieldWithHelpText,
    "InvenioAppRdm.Deposit.RelatedWorksField.container": RelatedWorksFieldNoEmptyValue,
    "InvenioAppRdm.Deposit.ReferencesField.container": ReferencesFieldNoEmptyValue,
}
